import React, { useContext, useEffect, useState } from 'react';
import Loading from '@/pages/dashboard/components/Loadings';
import { stringToJson } from '@/pages/dashboard/utils/stringToJson';
import { CommonPageRenderType, IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import { getPageConfig } from '../../services/benchmark';
import { LayoutContext } from '../../state/LayoutContext';
import { FRAME_TYPE_MAP } from '../../_config/constant';
import classNames from 'classnames';
import Render from '@/pages/dashboard/components/PageContainer/Render';

import './index.scss';

interface Iprops extends CommonPageRenderType {
  className?: string;
  style?: React.CSSProperties;
}
const CommonPageRender = (props: Iprops) => {
  const { reqParams, pageConfigInit, className, style } = props;
  const { frameType, metricConfig, currentMenu } = useContext(LayoutContext);

  const [pageConfig, setPageConfig] = useState<IPageConfigType>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPageConfig({
      frame_type: FRAME_TYPE_MAP?.[frameType],
      path: reqParams,
    }).then(res => {
      const resDataConfig = res?.view_config;
      const config = resDataConfig ? stringToJson(resDataConfig) : pageConfigInit;
      // const toBackendConfig = jsonToString(pageConfigInit)
      // console.log('入库配置',toBackendConfig)
      setPageConfig(config);
      setLoading(false);
    }).catch((err) => {
      console.log('后端配置错误或者配置为空', err);
      setPageConfig(pageConfigInit);
      setLoading(false);
    });
  }, []);

  return (
    <>
      {loading ?
        <Loading /> : (pageConfig && <div className={classNames('dbb-custom-page-box', className)} style={style}>
          <Render data={{ frameType, metricConfig, currentMenu, uid: frameType }} config={pageConfig} />
        </div>)
      }
    </>
  );
};

export default CommonPageRender;
